export default __webpack_public_path__ + "static/media/chat.99e64567.svg";